import { ContentSaveAlertIcon } from './ContentSaveAlertIcon';

/**
 * author: Michael Richins
 * id E4BAD28B-B196-42B5-BD4D-92C81A8EADAE
 * name content-save-alert
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/content-save-alert.svg
 * tags
 * - Alert / Error 
 */
export const FloppyDiscAlertIcon = ContentSaveAlertIcon;
export default FloppyDiscAlertIcon